<template lang="html">
    <div class="container-fluid p-2 p-lg-5">
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        Agent List
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="row search-form">
                                    <div class="col-md-3 mt-1">
                                        <input type="text" v-model="filter.name" class="form-control" placeholder="Name">
                                    </div>
                                    <div class="col-md-3 mt-1">
                                        <input type="text" v-model="filter.phone" class="form-control" placeholder="Phone">
                                    </div>
                                    <div class="col-md-3 mt-1">
                                        <input type="text" v-model="filter.code" class="form-control" placeholder="Code">
                                    </div>
                                    <div class="col-md-3 mt-1">
                                        <button class="btn btn-primary mr-1 fbutton" @click="search()"><i class="fas fa-search"></i> Search</button>
                                        <button class="btn btn-info fbutton" @click="reset()"><i class="fas fa-sync"></i> Refresh</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mt-4">
                            <table class="common-table">
                                <thead>
                                    <tr>
                                        <th v-for="(value, key) in columns" :key="key" @click="sortBy(key)" style="cursor:pointer">
                                            {{ value }}
                                            <span v-if="filter.sortKey === key">
                                                <i v-if="filter.orderBy === 'asc'" class="fas fa-sort-up"></i>
                                                <i v-else class="fas fa-sort-down"></i>
                                            </span>
                                        </th>
                                        <th>Commission</th>
                                        <th>Bank Info</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(data, index) in dataList" :key="data.id">
                                        <td>{{ data.code }}</td>
                                        <td>{{ data.name }}</td>
                                        <td>{{ data.phone }}</td>
                                        <td>{{ data.email }}</td>
                                        <td>{{ data.created_at }}</td>
                                        <td>
                                            <button v-b-modal.bv-modal-commission class="btn btn-action text-primary" @click="commissionDetail(data)"><i class="fas fa-coins"></i> Commission</button>
                                        </td>
                                        <td>
                                            <button class="btn btn-option text-primary" @click="bankInfoList(data)"><i class="fas fa-bank"></i></button>
                                        </td>
                                        <td>
                                            <button class="btn btn-option text-primary" @click="editData(data)"><i class="fas fa-edit"></i></button>
                                            <button v-b-modal.bv-modal-delete class="btn btn-option text-danger" @click="deleteData(data)"><i class="fas fa-trash-alt"></i></button>
                                        </td>
                                    </tr>
                                    <tr v-if="dataList.length === 0">
                                        <td :colspan="Object.keys(columns).length + 1" class="text-center">Empty List</td>
                                    </tr>
                                </tbody>
                            </table>

                            <div class="table-pagination-minimal">
                                <div class="table-pagination-row">
                                    <div v-if="dataList.length > 0 " class="table-info-minimal left-align">
                                        Showing <span>{{metaData.from}}</span> to <span>{{metaData.to}}</span> of <span>{{metaData.total}}</span> entries
                                    </div>
                                    <nav class="pagination-minimal">
                                        <ul>
                                            <li :class="{ 'disabled': metaData.prev_page_url === null }">
                                                <button @click.prevent="next(metaData.current_page-1)" :disabled="metaData.prev_page_url === null">
                                                    <i class="fas fa-angle-left"></i>
                                                </button>
                                            </li>
                                            <li v-for="page in metaData.last_page" :key="page"
                                                :class="{ 'active':metaData.current_page === page }"
                                                v-if="Math.abs(page - metaData.current_page) < 3 || page == metaData.last_page || page == 1">
                                                <button @click.prevent="next(page)">{{ page }}</button>
                                            </li>
                                            <li :class="{ 'disabled': metaData.current_page === metaData.last_page }">
                                                <button @click.prevent="next(metaData.current_page+1)" :disabled="metaData.current_page === metaData.last_page">
                                                    <i class="fas fa-angle-right"></i>
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                        <b-modal id="bv-modal-commission" ref="my-modal" title="Commission Data" hide-footer size="lg" dialog-class="commission-modal-lg">
                            <ul class="list-group" v-if="commissionData.commission_data">
                                <li class="list-group-item">
                                    Agent Name
                                    <span class="badge text-primary rounded-pill badge-16">{{ commissionData.name }}</span>
                                </li>
                                <li class="list-group-item align-items-center">
                                    Handicap
                                    <span class="badge text-primary rounded-pill badge-16">Upper : {{ commissionData.commission_data.body_high_rate }}</span>
                                    <span class="badge text-primary rounded-pill badge-16">Lower : {{ commissionData.commission_data.body_low_rate }}</span>
                                </li>
                                <li class="list-group-item d-flex justify-content-between align-items-center">
                                    Accumulator
                                    <badge class="badge text-primary rounded-pill badge-16">2 : {{ commissionData.commission_data.moung_two_rate }}</badge>
                                    <badge class="badge text-primary rounded-pill badge-16">3 : {{ commissionData.commission_data.moung_three_rate }}</badge>
                                    <badge class="badge text-primary rounded-pill badge-16">4 : {{ commissionData.commission_data.moung_four_rate }}</badge>
                                    <badge class="badge text-primary rounded-pill badge-16">5 : {{ commissionData.commission_data.moung_five_rate }}</badge>
                                    <badge class="badge text-primary rounded-pill badge-16">6 : {{ commissionData.commission_data.moung_six_rate }}</badge>
                                    <badge class="badge text-primary rounded-pill badge-16">7 : {{ commissionData.commission_data.moung_seven_rate }}</badge>
                                    <badge class="badge text-primary rounded-pill badge-16">8 : {{ commissionData.commission_data.moung_eight_rate }}</badge>
                                    <badge class="badge text-primary rounded-pill badge-16">9 : {{ commissionData.commission_data.moung_nine_rate }}</badge>
                                    <badge class="badge text-primary rounded-pill badge-16">10 : {{ commissionData.commission_data.moung_ten_rate }}</badge>
                                    <badge class="badge text-primary rounded-pill badge-16">11 : {{ commissionData.commission_data.moung_eleven_rate }}</badge>

                                </li>
                            </ul>                    
                        </b-modal>
                        <b-modal id="bv-modal-delete" ref="my-modal" title="Delete" hide-footer>
                            <p class="my-4">Are you sure to delete ? </p>
                            <p class="my-4 text-danger">{{alert}}</p>
                            <b-button class="mt-3 btn-danger" block @click="deleteItem()">Delete</b-button>
                        </b-modal>
                        <router-link class="float" to="agent-create">
                            <i class="fa fa-plus my-float" style="padding: 37%;"></i>
                        </router-link>
                    </div> <!-- close card-body -->
                </div> <!-- close card -->
            </div> <!-- close col-md-12 -->
        </div> <!-- close row -->
    </div> <!-- close container-fluid -->
</template>

<script lang="js">
    import {
        mapState,
        mapActions
    } from 'vuex'
    import env from '../../enviorments'
    import Loading from 'vue-loading-overlay'
    import 'vue-loading-overlay/dist/vue-loading.css';
    export default {
        name: 'agentList',
        metaInfo: {
            title: "Agent List",
            titleTemplate: "%s ← BXB",
        },
        components: {
            Loading
        },
        data() {
            return {
                env,
                isLoading: false,
                fullPage: true,
                alert: "",
                id: '',
                dataList: [],
                commissionData: [],
                permissions: '',
                columns: {
                    code: "Code",
                    name: "Name",
                    phone: "Phone",
                    email: "Email",
                    created_at: "Created At"
                },
                filter: {
                    page: 1,
                    orderBy: "asc",
                    sortKey: "created_at",
                    limit: 10,
                    name: "",
                    phone: "",
                    code: ""
                },
                metaData: {
                    last_page: null,
                    current_page: 1,
                    from: null,
                    to: null,
                    total: null,
                    prev_page_url: null
                }
            }
        },
        watch: {
        '$route' (to, from) {
            this.fetchData()
        }
    },
        computed: {},
        methods: {
            ...mapActions({
                agentListAction: 'agentListAction',
                agentDeleteAction: 'agentDeleteAction',
            }),
            sortBy(column) {
                this.filter.sortKey = column
                if (this.filter.sortKey == column) {
                    if (this.filter.orderBy == "asc") {
                        this.filter.orderBy = "desc"
                    } else if (this.filter.orderBy == "desc") {
                        this.filter.orderBy = "asc"
                    }
                } else {
                    this.filter.orderBy = "asc"
                }
                this.fetchData()
            },
            async search() {
                this.filter.page = 1
                this.fetchData()
                this.$refs['my-modal'].hide()
            },
            async fetchData() {
                this.isLoading = true
                let option = this.filter
                await this.agentListAction({
                    ...option
                }).then(res => {
                    if (res.success == true) {
                        this.dataList = res.data.data
                        this.metaData.last_page = res.data.meta.lastPage
                        this.metaData.current_page = res.data.meta.currentPage
                        this.metaData.prev_page_url = res.data.meta.prevPageUrl
                        this.metaData.from = res.data.meta.from
                        this.metaData.to = res.data.meta.to
                        this.metaData.total = res.data.meta.total
                        this.$router.replace({ 
                            path: 'agent-list', 
                            query: { 
                                page: this.filter.page, 
                                orderBy: this.filter.orderBy, 
                                sortKey: this.filter.sortKey, 
                                name: this.filter.name,
                                phone: this.filter.phone,
                                code: this.filter.code
                            } 
                        }).catch(()=>{})
                        this.isLoading = false;
                    }
                }).catch(err => this.isLoading = true)
            },
            next: function (page) {
                this.filter.page = page
                this.fetchData();
            },
            reset(){
                this.$router.replace({ 
                    path: 'agent-list', 
                    query: {
                        page: 1, 
                        orderBy: 'desc', 
                        sortKey: 'created_at', 
                        name: '',
                        phone: '',
                        code: ''
                    } 
                }).catch(()=>{})
                this.$router.go()
            },
            editData(data) {
                this.$router.replace({ 
                    path: 'agent-edit', 
                    query: { 
                        page: this.filter.page, 
                        orderBy: this.filter.orderBy, 
                        sortKey: this.filter.sortKey, 
                        id: data.id, 
                        name: this.filter.name,
                        phone: this.filter.phone,
                        code: this.filter.code
                    } 
                }).catch(()=>{})
            },
            bankInfoList(data) {
                this.$router.replace({
                    path: 'agent-bank-info',
                    query: {
                        page: this.filter.page,
                        orderBy: this.filter.orderBy,
                        sortKey: this.filter.sortKey,
                        id: data.id,
                        name: this.filter.name,
                        phone: this.filter.phone,
                        code: this.filter.code
                    }
                }).catch(()=>{})
            },
            deleteData(data){
                this.id = data.id
                this.alert = ""
            },
            async deleteItem() {
				this.isLoading = true
				let option = {
					id: this.id,
				}
				await this.agentDeleteAction({
					...option
				}).then(res => {
					if(res.status == 'fail'){
                        this.alert = res.message
                    }else{
                        this.$refs['my-modal'].hide()
                    }
                    this.fetchData()
                    this.isLoading = false;
				}).catch(err => this.isLoading = true)
			},
            commissionDetail(data) {
                this.commissionData = data
            },
            checkPermission: function (key) {
                if(key in this.permissions){
                    return true
                }else{
                    return false
                }
            }

        },
        mounted() {
            let user = JSON.parse(window.localStorage.getItem('user'))
            this.permissions = user.permissions
            this.filter.page = this.$route.query.page
            this.filter.orderBy = this.$route.query.orderBy
            this.filter.sortKey = this.$route.query.sortKey
            this.filter.name = this.$route.query.name
            this.filter.phone = this.$route.query.phone
            this.filter.code = this.$route.query.code
            this.fetchData()
        }
    }
</script>
<style scoped lang="scss">
/* Large commission modal custom width */
.commission-modal-lg .modal-dialog {
    max-width: 900px;
}
   .badge-16 {
    font-size: 16px;
   }
</style>